import * as Yup from 'yup';

export const trunkTypeSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    headerValue: Yup.string()
        .required('Header value is required')
        .test(
            'no-spaces',
            'Header value cannot have spaces',
            (value) => !value || !value.includes(' '),
        ),
    minChannels: Yup.number()
        .typeError('Minimum channels is required')
        .required('Minimum channels is required')
        .min(0, 'Minimum channels is required'),
    incSize: Yup.number()
        .typeError('Increment size is required')
        .required('Increment size is required')
        .test(
            'divides-min-channels',
            'Increment size must be divisible by minimum channels',
            function testIncSizeDivides(value) {
                const { minChannels } = this.parent;
                if (
                    !value ||
                    minChannels == null ||
                    Number.isNaN(minChannels)
                ) {
                    return true;
                }
                return minChannels % value === 0;
            },
        ),
});
